module.exports = "/desktop-app/assets/img/close.svg?c042967b794c63a8b7ee768102a67d70";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/close.svg
// module id = V9ta
// module chunks = 1